export default application => {
  const RELEASE_DOCUMENT_SPLIT_MS = 1714950000000;
  const APP_CREATED_MS = new Date(application.createdAt).getTime();

  return RELEASE_DOCUMENT_SPLIT_MS > APP_CREATED_MS;
};
